import React from 'react';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import I18n from 'i18n-js';
import ShieldIcon from '@reverbdotcom/cadence/icons/brand/protection-orange.svg';
import SpeakerIcon from '@reverbdotcom/cadence/icons/brand/report-orange.svg';
import HelpCard from '../discovery/help_card';
import { useHelpCenterArticleUrl } from '@reverbdotcom/commons/src/url_helpers';
import { TAXES_HELP_CENTER_ARTICLE_ID } from './tax_profile_helpers';

export function TaxProfileFooter() {
  const helpCenterArticleUrl = useHelpCenterArticleUrl(TAXES_HELP_CENTER_ARTICLE_ID);

  return (
    <div className='g-container .g-container--cycle'>
      <div className='g-col-6 pt-5 g-col-mobile-12 mobile-mb-2'>
        <HelpCard
          svgIcon={ShieldIcon}
          iconAlt={I18n.t('discovery.taxProfile.footer.shieldAlt')}
        >
          <p className='weight-bold'>
            <Translate
              text="discovery.taxProfile.footer.whyThisChangeHeader"
            />
          </p>
          <p>
            <Translate
              text="discovery.taxProfile.footer.whyThisChangeParagraph1"
            />
          </p>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.whyThisChangeParagraph2"
          >
            <a href={helpCenterArticleUrl} className="text-link">
              <Translate text="discovery.taxProfile.helpCenterLinkText" />
            </a>
          </Translate>
        </HelpCard>
      </div>
      <div className='g-col-6 pt-5 g-col-mobile-12'>
        <HelpCard
          svgIcon={SpeakerIcon}
          iconAlt={I18n.t('discovery.taxProfile.footer.speakerAlt')}
        >
          <p className='weight-bold'>
            <Translate
              text="discovery.taxProfile.footer.advocacyHeadline"
            />
          </p>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.advocacyParagraph1"
          >
            <a href="https://1099kfairness.org/issue" className="text-link">
              <Translate text="discovery.taxProfile.footer.advocacyLearnMore" />
            </a>
          </Translate>
          <Translate
            tag="p"
            text="discovery.taxProfile.footer.advocacyParagraph2"
          >
            <a href="https://1099kfairness.org/engage/take-action" className="text-link">
              <Translate text="discovery.taxProfile.footer.advocacySendALetter" />
            </a>
          </Translate>
        </HelpCard>
      </div>
    </div>
  );
}

export default TaxProfileFooter;
